import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import Box from '@mui/material/Box'
import MuiMenu from '@material-ui/icons/Menu';
import {hamburger as HamburgerIcon }  from '~/assets'

import Hidden from '@material-ui/core/Hidden';
import { SkillsBiteLogo } from '~/assets';
import Grid from '@mui/material/Grid';
import { Typography, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/core/styles';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import { IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useRef } from 'react';
import {Link} from 'react-scroll'
import { Link as ReactLink, BrowserRouter } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import pdf from '../../assets/whitepaper.pdf'
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { style } from '@mui/system';

const useStyles = makeStyles((theme) => ({
  logoStyle: {
    // height: "80%",
    // width: "80%",
    [theme.breakpoints.down('sm')]: {
      height: '90%',
      width: '90%',
    },
  },
  imageStyle: {
    padding: '0px 10px 0px 15px',
    justifyContent: 'space-around',
  },
  typographyGrid: {
    display: 'flex',
    flexDirection: 'row',
  },
  typographyText: {
    padding: '15px',
    color: '#C6C6C6',
    cursor: 'pointer'
  },
  btnGrid: {
    padding: '10px',
  },
  hamburger:{
    [theme.breakpoints.up('lg')]: {
      display: 'none !important',
    },
  },
  menuGrid: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  typographyBreakpoint: {
    
    [theme.breakpoints.down('md')]: {
      display: 'none !important',
    },
  },
  tooltiptext:{
    visibility:'hidden',
    width: '100px',
    backgroundColor: 'black',
    color:'#fff',
    textAlign:'center',
    padding:'5px 0',
    borderRadius:'8px',
    position:'absolute',
    zIndex:1,
    '&:hover':{
      visibility: 'visible'
    }
  },
  button:{
    padding:'10px 20px !important',
    [theme.breakpoints.down(362)]: {
      padding: '5px 10px !important'
    },
  }
}));

export const Header = () => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false)

  const toggleDrawer = (command: boolean) => {
    setOpen(command)
  }

  return (
    <Box display='flex' justifyContent='center' style={{backgroundColor: 'black', zIndex:10}} position='fixed' width='100%'>
    {/* <AppBar sx={{ background: 'black' }}>
      <Toolbar> */}
        <Box
          // marginY={2}
          display="flex"
          justifyContent='space-between'
          alignItems="center"
          width="100%"
          padding={1}
          
          
          // bgcolor="red"
          
        >
          <Box className={classes.hamburger} display='flex' justifyContent='center' alignItems='center' onClick={() => toggleDrawer(true)}>
            <img src={HamburgerIcon}></img>
          </Box>

          
          <Box
            className={classes.imageStyle}
            // width={200}
            display="flex"
            justifyContent="center"
            alignItems="center"
            
          >
            <Link
                activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
            
            <img
              className={classes.logoStyle}
              src={SkillsBiteLogo}
              alt="Logo"
              style={{
                cursor: 'pointer'
              }}
            />

            </Link>
          
         
          </Box>
          
          <Box className={classes.typographyBreakpoint} display="flex" flex={0.7} justifyContent="center">
            <Box
              justifyContent={'center'}
              sx={{ paddingRight: '1px' }}
              display="flex"
            >
              {/* <Box item xs={1} justifyContent={"space-evenly"}></Box> */}
              <Box
                className={classes.typographyBreakpoint}
                justifyContent={'space-evenly'}
                display="flex"
              >
                 <Link
                activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Home
                </Typography>
                </Link>

                <Link
                activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={500}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  About
                </Typography>
                </Link>
              </Box>

              <Box
                className={classes.typographyBreakpoint}
                display="flex"
              >

                <Link
                activeClass='active'
                to='ecosystem'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Ecosystem
                </Typography>
                </Link>


                <Link
                activeClass='active'
                to='tokenomics'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Tokenomics
                </Typography>
                </Link>

              </Box>
              <Box
                className={classes.typographyBreakpoint}
                display="flex"
              >
                <Link
                activeClass='active'
                to='roadmap'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Roadmap
                </Typography>
                </Link>
              </Box>
              <Box
                className={classes.typographyBreakpoint}
                display="flex"
              >
                <Link
                activeClass='active'
                to='team'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Team
                </Typography>
                </Link>
              </Box>

              <Box className={classes.typographyBreakpoint} display="flex">

                <Link
                activeClass='active'
                to='partner'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                >
                <Typography className={classes.typographyText} variant="body2">
                  Partners
                </Typography>
                </Link>

                <a style={{textDecoration:"none"}} href={pdf} target='_blank' rel='noreferrer'>
                <Typography className={classes.typographyText} variant="body2">
                  Whitepaper
                </Typography>
                </a>


              </Box>
            </Box>
          </Box>

          
          <Box
            display="flex"
            width={{xs:136, lg:144}}
            height={42}
            justifyContent="center"
            alignItems="center"
            paddingLeft={{xs:0, lg:9}}
            marginRight={{xs:0, sm:2}}
          >
            <Tooltip title='Coming Soon' enterTouchDelay={-100}>
            <Button
              variant="contained"
              className={classes.button}
              // width={{xs:136, lg:144}}
              // height={{xs:38, lg:42}}
              sx={{
                position:'relative',
                // height: 144,
                // width
                backgroundColor: '#fff',
                color: '#000',
                borderRadius: '10px',
                width:{xs:126, lg:144},
                height:{xs:32,lg:42}

                
                
                // margin: "5px 10px 5px 90px",
                // padding: '5px',
              }}
            >
              <Typography fontWeight="500px" fontSize={{ xs: "12px"}} color="#000000">
              Token Panel
              </Typography>
            </Button>
            </Tooltip>
          </Box>
         


          {/* <Box item md={2} className={classes.menuBox}>
          <IconButton aria-label="Menu">
            <MenuRoundedIcon style={{ background: "#fff" }} />
          </IconButton>
        </Box> */}
        </Box>
      {/* </Toolbar>
    </AppBar> */}


    <Drawer anchor='top' open={open} onClose={()=> toggleDrawer(false)}
    PaperProps={{style:{backgroundColor:"#141420"}}}
    >
      <List>

        <Link activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Home</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={400}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">About</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='ecosystem'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Ecosystem</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='tokenomics'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Tokenomics</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='roadmap'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Roadmap</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='team'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Team</Typography>
            </ListItemText>
          </ListItem>
        </Link>

        <Link activeClass='active'
                to='partner'
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
        >
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
            <ListItemText>
              <Typography variant="body2">Partners</Typography>
            </ListItemText>
          </ListItem>
        </Link>

       
          <ListItem onClick={()=>toggleDrawer(false)} sx={{backgroundColor:"#141420"}} button>
          <a style={{textDecoration:"none"}} href={pdf} target='_blank' rel='noreferrer'>
          <ListItemText>
              <Typography variant="body2">Whitepaper</Typography>
            </ListItemText>  
          </a>
          </ListItem>
        



      </List>
    </Drawer>
    </Box>
  );
};
